export enum SegmentState {
  /**
   * The segment list is idle and ready for interaction
   */
  IDLE = 'IDLE',

  /**
   * The segment list is disabled or out of service
   */
  DISABLED = 'DISABLED',

  /**
   * State reflecting processes prior to the actual editing of a segment
   */
  PRE_EDITING = 'PRE_EDITING',

  /**
   * A segment is currently being edited
   */
  EDITING = 'EDITING',

  /**
   * State reflecting processes prior to the actual creation of a segment
   */
  PRE_CREATING = 'PRE_CREATING',

  /**
   * A new segment is being created
   */
  CREATING = 'CREATING',

  /**
   * State reflecting processes prior to the actual removal of a segment
   */
  PRE_REMOVING = 'PRE_REMOVING',

  /**
   * A segment is being removed
   */
  REMOVING = 'REMOVING',

  /**
   * Segments are being reordered or their positions are being adjusted
   */
  REORDERING = 'REORDERING',

  /**
   * The segment list is being loaded or initialized
   */
  LOADING = 'LOADING',

  /**
   * Changes to the segment list are being saved
   */
  SAVING = 'SAVING',

  /**
   * An error has occurred during an operation
   */
  ERROR = 'ERROR',
}

export default SegmentState;
